import { CSSProperties } from "react";
import { TSvgIcon, TAntdIcon } from "types";
import { IconColors, IconSizes } from "constants/icons";

type IconSize = keyof typeof IconSizes | number;
type IconColor = keyof typeof IconColors | string;

interface IconProps {
    icon?: TSvgIcon | TAntdIcon;
    onClick?: () => void;
    color?: IconColor;
    style?: CSSProperties;
    size?: IconSize;
    [key: string]: unknown;
}

const Icon = ({ icon: IconComp, color = "base", onClick, style, size = "md", ...rest }: IconProps) => {
    if (!IconComp) return null;

    const resolvedSize = typeof size === "number" ? size : IconSizes[size];
    const resolvedColor = color in IconColors ? IconColors[color as keyof typeof IconColors] : color;

    return (
        <IconComp
            width={resolvedSize}
            height={resolvedSize}
            fontSize={resolvedSize}
            onClick={onClick}
            color={resolvedColor}
            style={{
                width: resolvedSize,
                height: resolvedSize,
                cursor: onClick ? "pointer" : "inherit",
                ...style,
            }}
            {...rest}
        />
    );
};

export default Icon;
